/**
 * Utility functions library.
 *
 * @version 1.2.0
 */

/* global _env */

import validator from 'validator';

export function disable( targets, bool ) {

  if( Object.prototype.toString.call(targets) === "[object HTMLCollection]" ){
    Array.prototype.filter.call( targets, ( target ) => {
      if ( bool ){
        target.setAttribute('disabled', 'disabled');
        target.setAttribute("style", "pointer-events:none;");
      }else{
        target.removeAttribute('disabled');
        target.removeAttribute('style');
      }
    });
  } else {
    if ( bool ){
      targets.setAttribute('disabled', 'disabled');
      targets.setAttribute("style", "pointer-events:none;");
    }else{
      targets.removeAttribute('disabled');
      targets.removeAttribute('style');
    }
  }

}

export function iff( condition ) {
  const thenMethod = (thenFunc) => {
    const elseMethod = (elseFunc) => condition ? thenFunc() : elseFunc();
    return { else: elseMethod };
  };
  return { then: thenMethod };
}

export function switchf( switchVal ){
  const caseMethod = (funcToDo) => (caseVal) => {
    const isFixedNow = !funcToDo && switchVal === caseVal;
    const thenMethod = (funcToDo, isFixedNow) => (thenFunc) => {
      const defaultMethod = (funcToDo) => (defaultFunc) => (funcToDo || defaultFunc)();
      return {
        case: caseMethod(isFixedNow ? thenFunc : funcToDo),
        default: defaultMethod(isFixedNow ? thenFunc : funcToDo)
      };
    };
    return { then: thenMethod(funcToDo, isFixedNow) };
  };
  return { case: caseMethod() };
}

export function htmlToNode( htmlStr, parent = 'div' ){

  if ( ! htmlStr || typeof htmlStr !== 'string' ) return '';

  const tmpElem = document.createElement( parent );

  // 対応ブラウザを考えinnerHTMLを使用.
  tmpElem.innerHTML = htmlStr.trim();

  return tmpElem.firstChild;

}

export function doAjax( action, obj, success, fail ){

	const forms = new FormData();
	forms.append('action', action );
	Object.keys(obj).forEach( (key) => {
		forms.append(key, obj[key]);
	});

	const headers = new Headers();
	headers.set( "x-csrf-token", _env.nonce );

	const url = `${_env.url}/${_env.project}?mode=ajax`;

	return fetch(
		url,
		{ headers, method: 'POST', body: forms, cache: 'no-cache' }
	)
		.then((response) => response.json())
		.then((data) => {
			if ( data.code !== 0 ) {
				fail(data);
			} else {
				success(data);
			}
		})
		.catch((error) => {
			fail(error);
		});
}

/**
 * Zipコードから住所を取得する
 *
 * @param zip
 * @param address    都道府県市区町村地名
 * @param pref       都道府県
 * @param city       市区町村
 * @param town       地名
 *
 * @return {boolean}
 */
export function zipToAddress( zip, address, pref = null, city = null, town = null ) {

	if( ! zip || ! zip.value ) {
		return false;
	}

	//全角を半角に変換
	const code = zip.value.replace(/[０-９]/g, (s) => {
		return String.fromCharCode(s.charCodeAt(0) - 65248);
	}).replace(/[‐－―]/g, "-");

	if( validator.isPostalCode( code, 'JP' ) ){

		jQuery.ajax({
			type: 'GET',
			url: 'https://api.zipaddress.net/?zipcode=' + code,
			dataType: 'json'
		})
			.then( ( data ) => {

				zip.value = code;

				if( pref ) {
					pref.value = data.data.pref;
				}

				if( city ) {
					city.value = data.data.city;
				}

				if( town ) {
					town.value = data.data.town;
				}

				if( address && validator.isEmpty( address.value )){
					address.value = data.data.fullAddress;
				}

			}, ( err ) => {

			} );
	}
}
